import axios from './axios.config';
import { PaginatedPollDto, PollDto, VotePollDto } from '../types';

/**
 * Poll API Service
 * Handles poll-related API calls for users
 */
class PollService {

  /**
   * Get all polls with pagination
   */
  async getPolls(params?: {
    page?: number;
    size?: number;
  }): Promise<PaginatedPollDto> {
    const searchParams = new URLSearchParams();
    if (params?.page !== undefined) searchParams.set('page', params.page.toString());
    if (params?.size !== undefined) searchParams.set('size', params.size.toString());

    const response = await axios.get<PaginatedPollDto>(`/polls?${searchParams}`);
    return response.data;
  }

  /**
   * Get poll details by ID
   */
  async getPollById(id: number): Promise<PollDto> {
    const response = await axios.get<PollDto>(`/polls/${id}`);
    return response.data;
  }

  /**
   * Get unvoted active polls
   */
  async getUnvotedPolls(): Promise<PollDto[]> {
    const response = await axios.get<PollDto[]>('/polls/unvoted');
    return response.data;
  }

  /**
   * Vote on a poll
   */
  async vote(id: number, data: VotePollDto): Promise<PollDto> {
    const response = await axios.post<PollDto>(`/polls/${id}/vote`, data);
    return response.data;
  }
}

// Export singleton instance
export const pollApi = new PollService();
